import { FC } from 'react';

import { Button } from 'ui/components/common';
import { useGoogleRegister } from 'modules/account/settings/hooks';
import { SIZE } from 'utils/constants';
import { cn } from 'utils/helpers';
import AddIntegrationsModal from 'modules/account/inbox/components/AddIntegrationsModal';

import useModal from '../Modal/useModal';

type ConnectToGoogleProps = {
  returnUrl: string;
};
export const ConnectToGoogle: FC<ConnectToGoogleProps> = ({ returnUrl }) => {
  const { hideModal } = useModal();

  const { mutate: registerGoogle } = useGoogleRegister();

  const onClick = () => {
    registerGoogle(
      {
        returnUrl,
        scope: 'EMAIL',
      },
      {
        onSuccess(data) {
          window.location.href = data;
        },
      },
    );
  };
  return (
    <div>
      <div className="space-y-6 text-xs text-secondary-base leading-5 tracking-wider">
        <div className="leading-5">
          {`When you integrate your Google account with the Leapify platform, 
        you can connect a number of Google services to your Leapify account. 
        By doing so, Leapify will be able to access data and information from your Google account. 
        Those services and types of data are outlined below:`}
        </div>

        <div className="ml-5 leading-5">
          <ul>
            <li className="list-disc">
              <span className="font-semibold">Gmail:</span>
              You can send and receive Gmail messages, schedule email sends, and
              modify email drafts in the Leapify app. You will also be able to
              log and track emails sent in-app. Leapify will have access to your
              Gmail data, like email headers, subject lines, and email bodies.
            </li>
          </ul>
        </div>

        <div>
          We'll only use your Google data to power different parts of our
          product that connect with the G Suite tools you use every day. It's
          your data. We just want to help you grow better.
        </div>

        <div>
          For more information on the Google integration and the types of data
          we can access, please see our Privacy Policy.
        </div>
      </div>
      <div
        className={cn(
          'flex justify-end gap-3',
          'px-2.5 pt-5 mt-5',
          'border-t-[0.5px] border-separator-primary',
        )}
      >
        <Button onClick={onClick} label="ACCEPT & CONNECT TO GOOGLE" />
        <Button onClick={hideModal} intent={'tertiary'} label="CANCEL" />
      </div>
    </div>
  );
};

const ComposerIntegrationDialog = () => {
  const { showModal } = useModal();

  const handleOnClick = () => {
    showModal({
      disableOutsideClick: false,
      resetPadding: true,
      hideHeader: true,
      title: 'Add Inbox',
      content: <AddIntegrationsModal />,
      size: SIZE.Medium,
    });
  };
  return (
    <div>
      <div className="p-[22px] space-y-4">
        <p className="font-semibold text-sm leading-[22px] tracking-wider">
          Keep track of your email activity in your CRM
        </p>
        <p className="text-sm tracking-wider leading-[22px]">
          Connect your email account to Leapify to begin sending emails from
          your CRM. All your email conversations will appear in the timeline
          below.
        </p>
        <Button onClick={handleOnClick} size={'md'} label="CONNECT AN EMAIL" />
      </div>
    </div>
  );
};

export default ComposerIntegrationDialog;
